import React from 'react';
import CircularProgressbar from 'react-circular-progressbar';

function StyledProgressbar(props) {
    var circleStyle = {
	      backgroundColor: props.color,
	      borderRadius: "50%",
	      width:60,
	      height:60,
	    };
  return (
	  <div style={{position: 'relative', width: '100px', height: '100px'}}>
	  	<div className="txt-title">{props.subject}</div>
    	  	<CircularProgressbar percentage={props.percentage} text={props.percentage} strokeWidth={5}
    	  		styles={{
    	  		    root: {},
    	  		    path: { stroke: props.color, strokeLinecap: 'round', transition: 'stroke-dashoffset 0.5s ease 0s' },
    	  		    trail: { stroke: '#ff000000' },
    	  		    text: { fill: '#ffffff', fontSize: '20px', dominantBaseline: 'middle', textAnchor: 'middle'}
    	  		}}
    	  	initialAnimation={true}/>
    	  	<div className="data-circle" style={circleStyle} />
	</div>

  );
}
export default StyledProgressbar;



// WEBPACK FOOTER //
// ./src/components/Containers/Graph/StyledProgressbar.js